import { FieldModel, FieldType, Group } from "../documentEditor/types";

export type FieldPosition = {
	x: number;
	y: number;
	page: number;
	width: number;
	height: number;
};

export type FieldTypeBff = {
	fieldDescription: string;
	fieldOptions: [];
	fieldPosition: FieldPosition;
	fieldRequired: boolean;
	fieldTitle: string;
	fieldType: string;
	fieldValue: string;
	fieldVisible: boolean;
	fieldId: number;
	fieldAssignee: string;
	fieldGroup?: string;
	fieldGroupColor?: string;
	autoGenerateInitials?: boolean;
};

export type FieldTypeBffAnalize = {
    fieldName: string;
    fieldType: string;
    fieldValue: string;
    key_bounds: FieldPosition;
    label: string;
    fieldId: number;
    source: string;
    value_bounds: null;
};

const mapFieldType = (type: string): FieldType => {
	switch (type) {
		case "text":
			return "shortText";
		case "number":
			return "number";
		case "date":
			return "date";
		case "checkbox":
			return "checkbox";
		case "signature":
			return "signature";
		case "initials":
		case "initial":
			return "initials";
		default:
			return "shortText";
	}
};

export const parseFields = (fields: FieldTypeBff[]): FieldModel[] => {
	console.log("parseFields", fields);
	return fields.map((field) => {
		return {
			id: field.fieldId.toString(),
			type: mapFieldType(field.fieldType),
			title: field.fieldTitle,
			bounds: {
				x: field.fieldPosition.x,
				y: field.fieldPosition.y,
				width: field.fieldPosition.width,
				height: field.fieldPosition.height,
				page: field.fieldPosition.page,
			},
			placeholder: field.fieldDescription,
			required: field.fieldRequired,
			checked: field.fieldValue === ":selected:",
		fieldId: typeof field.fieldId === 'string' ? parseInt(field.fieldId) : field.fieldId,
		signatureRole: field.fieldAssignee as 'sender' | 'recipient' || "recipient",
		fieldGroup: field.fieldGroup,
		fieldGroupColor: field.fieldGroupColor,
		autoGenerateInitials: Boolean(field.autoGenerateInitials),
	};
	});
};export const parseFieldsToBff = (fields: FieldModel[]): FieldTypeBff[] => {
	return fields.map((field, index) => {
		return {
			fieldId: index + 1,
			fieldTitle: field.title,
			fieldDescription: field.placeholder || "",
			fieldRequired: field.required ?? false,
			fieldType: field.type,
			fieldValue: field.checked ? ":selected:" : "",
			fieldVisible: true,
			fieldPosition: {    
                x: field.bounds.x,
                y: field.bounds.y,
                width: field.bounds.width,
                height: field.bounds.height,
                page: field.bounds.page,
			},  
            fieldOptions: [],
			fieldAssignee: field.signatureRole || "recipient",
			fieldGroup: field.fieldGroup,
			fieldGroupColor: field.fieldGroupColor,
			autoGenerateInitials: Boolean(field.autoGenerateInitials),
		};
	});
};

export const parseFieldsAnalize = (fields: FieldTypeBffAnalize[]): FieldModel[] => {
	return fields.map((field) => {
		return {
			id: field.fieldId.toString(),
			type: mapFieldType(field.fieldType),
			title: field.label,
			bounds: {
				x: field.key_bounds.x,
				y: field.key_bounds.y,
				width: field.key_bounds.width,
				height: field.key_bounds.height,
				page: field.key_bounds.page,
			},
			placeholder: field.label,
			required: false,
			checked: false,
			fieldId: Number(field.fieldId),
		};
	});
};
